module.exports = ".text {\n    text-align: center;\n    font-size: 18px;\n    font-weight: lighter;\n}\n"